import React from 'react';
import { steps } from '../data/religione';
export function HowItWorks() {
  return <section className="w-full border-y border-slate-900/10 bg-stone-100 px-8 py-24 sm:px-14 sm:py-32" data-id="element-183" data-mp="7slouvmylvq0">
      <div className="mx-auto max-w-6xl" data-id="element-184" data-mp="3pyrocy9gisb3">
        <div className="grid gap-8 lg:grid-cols-12 lg:items-end" data-id="element-185" data-mp="3q02qyur61u0m">
          <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl lg:col-span-7" data-id="element-186" data-mp="3tzk0q0dmldbl">
            Come funziona <em className="text-red-700" data-id="element-187" data-mp="lktiieiy56kh">RELIGIONE PRONTA™</em>
          </h2>
          <p className="text-lg leading-relaxed text-slate-900/75 lg:col-span-5" data-id="element-188" data-mp="qibj9hmt8fhe">
            Dal download all'aula: prepari la prossima lezione in soli cinque minuti.
          </p>
        </div>

        <ol className="mt-16 grid gap-10 sm:grid-cols-2 lg:grid-cols-4 lg:gap-8" data-id="element-189" data-mp="gsi7ogmo40d5">
          {steps.map((step, index) => <li key={step.title} className="relative border-t-2 border-slate-900 pt-6" data-id="element-190" data-mp="14ick4x32rmwv" data-mpi={index}>
              <span className="font-serif text-5xl italic leading-none text-red-700" aria-hidden="true" data-id="element-191" data-mp="19aw6ojjqpsdt">
                {index + 1}
              </span>
              <h3 className="mt-4 font-serif text-2xl leading-tight text-slate-900" data-id="element-192" data-mp="2rjbm5hh6d8t9">
                <span className="sr-only" data-id="element-193" data-mp="2mki5xhai73pe">Passo {index + 1}: </span>
                {step.title}
              </h3>
              <p className="mt-2 leading-relaxed text-slate-900/70" data-id="element-194" data-mp="2wkr3ozk58x6w">{step.text}</p>
            </li>)}
        </ol>

        <p className="mt-16 text-center font-serif text-2xl italic leading-snug text-slate-900/80 sm:text-3xl" data-id="element-195" data-mp="3abvy9n8nmzad">
          Apri → scegli → preparati → insegna. Semplice e strutturato.
        </p>
      </div>
    </section>;
}